import React from "react";
import {
  ActionContainer,
  Logo,
  MainContainer,
  OptionItem,
  TitleContainer,
} from "./styles";
import LogoWhite from "../../../../assets/svg/logo-white.svg";
import CompanySelection from "./components/CompanySelection";
import UserPopover from "../../../../components/UserPopover";
import { Row } from "../../../../themes/globalStyle";
import Typography from "../../../../components/Typography";
import useAdmin from "../../hooks/useAdmin";

const TopBar: React.FC = (): JSX.Element => {
  const { adminState, updateState } = useAdmin();

  const ScreenSelection = () => (
    <Row>
      <OptionItem onClick={() => updateState({ selectedScreen: "CRUD" })}>
        <Typography
          text={"CRUD"}
          size="medium"
          color="Bg300"
          weight={adminState.selectedScreen === "CRUD" ? 800 : 200}
        />
      </OptionItem>
      <OptionItem onClick={() => updateState({ selectedScreen: "USER" })}>
        <Typography
          text={"Usuários"}
          size="medium"
          color="Bg300"
          weight={adminState.selectedScreen === "USER" ? 800 : 200}
        />
      </OptionItem>
      <OptionItem onClick={() => updateState({ selectedScreen: "POST" })}>
        <Typography
          text={"Postagens"}
          size="medium"
          color="Bg300"
          weight={adminState.selectedScreen === "POST" ? 800 : 200}
        />
      </OptionItem>
    </Row>
  );

  return (
    <MainContainer>
      <TitleContainer>
        <Logo src={LogoWhite} />
        <ScreenSelection />
        {(adminState.selectedScreen === "CRUD" ||
          adminState.selectedScreen === "POST") && <CompanySelection />}
      </TitleContainer>
      <ActionContainer>
        <UserPopover />
      </ActionContainer>
    </MainContainer>
  );
};

export default TopBar;
